import { inject, Injectable } from '@angular/core';
import { Registration } from '../models/registration.model';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService {
  private readonly _serviceKey = 'registration';
  private readonly _blazorService = inject(HsBlazorService);

  public async create(dto: Registration): Promise<Registration | undefined> {
    const registration = await this._blazorService.invokeService(
      this._serviceKey,
      'Create',
      dto,
    );

    return registration as Registration | undefined;
  }

  public async update(dto: Registration): Promise<Registration | undefined> {
    const registration = await this._blazorService.invokeService(
      this._serviceKey,
      'Update',
      dto,
    );

    return registration as Registration | undefined;
  }
}
